import { useRef, useCallback } from 'react'

export function useUploadQueue(backendUrl, onUploadSuccess, onUploadError) {
    const queueRef = useRef([])
    const isProcessingRef = useRef(false)
    const onSuccessRef = useRef(onUploadSuccess)
    const onErrorRef = useRef(onUploadError)
    onSuccessRef.current = onUploadSuccess
    onErrorRef.current = onUploadError

    const enqueue = useCallback((imageBlob, metadata) => {
        queueRef.current.push({ imageBlob, metadata, retries: 0 })
        if (!isProcessingRef.current) processQueue()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    async function processQueue() {
        if (queueRef.current.length === 0) {
            isProcessingRef.current = false
            return
        }
        isProcessingRef.current = true
        const item = queueRef.current[0]
        try {
            const formData = new FormData()
            formData.append('image', item.imageBlob, 'face.jpg')
            formData.append('metadata', JSON.stringify(item.metadata))
            const response = await fetch(`${backendUrl}/upload`, { method: 'POST', body: formData })

            if (response.status >= 400 && response.status < 500) {
                // Client error — non-retriable: drain queue and report error
                const body = await response.json().catch(() => ({}))
                queueRef.current = []
                isProcessingRef.current = false
                onErrorRef.current?.(body.message ?? `Erreur ${response.status}`)
                return
            }

            if (!response.ok) throw new Error(`HTTP ${response.status}`)

            queueRef.current.shift()
            onSuccessRef.current?.()
        } catch {
            if (item.retries < 3) {
                item.retries++
                await new Promise(r => setTimeout(r, 1000 * item.retries))
            } else {
                queueRef.current.shift()
            }
        }
        processQueue()
    }

    return { enqueue }
}
